import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import Carregando from '@/components/Carregando';

/**
 * Exige sessão. Opcionalmente restringe a um conjunto de papéis.
 *
 * ★★ WO (2/out/2026) — `recusaPara`: PARA ONDE vai quem é recusado.
 *
 * O padrão continua `/sem-acesso`, e é o certo para porta FECHADA ("você não tem permissão").
 * ⚠ Mas o painel de Produtividade está escondido por **bandeira de disponibilidade**: a tela
 * existe e ainda não foi liberada para a equipe. Mandar para "Sem permissão" ANUNCIARIA que há
 * algo ali — e a decisão do dono é que a equipe não saiba que a seção existe.
 *
 * ★ Então a recusa por bandeira é SILENCIOSA: vai para a tela inicial, sem faixa e sem texto.
 * ⚠ Houve uma versão com aviso na tela; o dono mandou tirar. Quem for repor um aviso está
 * revertendo decisão de produto.
 *
 * ★ Por que AQUI e não num portão novo: a guarda da VU (`vu.guardas.test.js`) lê o `App.jsx`
 * como TEXTO e só enxerga `<RequireAuth papeis={…}>`. Um segundo componente de portão ficaria
 * **invisível** para ela, e o invariante "item visível no menu ⇔ rota aceita o papel" deixaria
 * de ser verificado sem ninguém notar. Estender este componente mantém a guarda enxergando.
 */
export default function RequireAuth({ papeis, recusaPara = '/sem-acesso' }) {
  const { carregando, autenticado, papel, semVinculo } = useAuth();
  const local = useLocation();

  if (carregando) return <Carregando texto="Verificando sessão…" />;

  if (!autenticado) {
    return <Navigate to="/entrar" replace state={{ de: local.pathname }} />;
  }

  if (semVinculo) return <Navigate to="/sem-vinculo" replace />;

  if (papeis && !papeis.includes(papel)) {
    return <Navigate to={recusaPara} replace />;
  }

  return <Outlet />;
}
